<template lang="pug">
aside-modal#tax-form-modal(width="w-xxxl", :loading="onLoading('save-tax')")
    span(slot="header-text") {{ taxExists ? 'Update' : 'Create' }} Tax
    div.p-a(slot="body")
        form#tax-form
            fieldset(:disabled="onLoading('save-tax')")
                .form-group
                    label.form-control-label Name
                    input.form-control(
                        type="text",
                        :value="tax.name",
                        @input="setTaxValue($event.target.value, 'name')",
                        placeholder="Service Tax"
                        required
                    )

                .form-group
                    label.form-control-label Short Name
                    input.form-control(
                        type="text",
                        :value="tax.short_name",
                        @input="setTaxValue($event.target.value, 'short_name')"
                        placeholder="SST"
                    )

                .form-group
                    label.form-control-label Amount ({{ taxText }})
                    input.form-control(
                        type="text",
                        data-parsley-type="number",
                        placeholder="0",
                        required,
                        @input="setTaxValue($event.target.value, 'amount')",
                        :value="tax.amount"
                    )

                //.form-group
                //    label.form-control-label Scopes
                //    select.md-input(
                //        v-model="tax.scope"
                //    )
                //        option(
                //            v-for="scope in scopes"
                //            :value="scope.id"
                //            :key="scope.id"
                //        ) {{ scope.name }}

                .form-group(v-show="tax.status == 1")
                    label.typo__label.multiselect-label Effective At
                    datepicker-input(
                        v-validate="{ required: tax.status }"
                        v-model="tax.effective_at"
                        name="effective at"
                        :min="min"
                    )

                    span.small.text-danger(v-show="errors.has('effective at')")
                        | {{ errors.first('effective at') }}

                .form-group(v-show="tax.status == 0")
                    label.typo__label.multiselect-label Ineffective At
                    datepicker-input(
                        v-validate="{ required: tax.status == 0 }"
                        v-model="tax.deactivate_at"
                        name="ineffective at"
                        :min="deactivateMinDate"
                    )

                    span.small.text-danger(v-show="errors.has('ineffective at')")
                        | {{ errors.first('ineffective at') }} 

                //.form-group
                //    label.form-control-label Application Mode
                //    multiselect(
                //        name="type"
                //        label="name"
                //        track-by="value"
                //        v-model="modeMultiselect"
                //        :allow-empty="false"
                //        :close-on-select="true"
                //        :multiple="false"
                //        :options="applicationModes"
                //        :show-labels="false"
                //    )

                .form-group
                    label.form-control-label Amount Mode
                    multiselect(
                        name="type"
                        label="name"
                        track-by="value"
                        v-model="inclusiveMultiselect"
                        :allow-empty="false"
                        :close-on-select="true"
                        :multiple="false"
                        :options="amountModes"
                        :show-labels="false"
                    )

                .form-group
                    label.form-control-label Item Type
                    multiselect(
                        name="item type"
                        label="name"
                        track-by="value"
                        v-model="taxItemType"
                        :allow-empty="false"
                        :close-on-select="true"
                        :multiple="false"
                        :options="itemTypes"
                        :show-labels="false"
                        v-validate="'required'"
                        :disabled="disableItemType"
                    )

                    span.small.text-danger(v-show="errors.has('item type')")
                        | {{ errors.first('item type') }}

                    button.btn.btn-sm.btn-block.white.m-t-1(
                        type="button"
                        @click="addOutlets"
                    )
                        | Add Stations

                    span.small.text-danger(v-show="errors.has('add outlet')")
                        | {{ errors.first('add outlet') }}

                    button.btn.btn-sm.btn-block.white.m-t-1(
                        v-if="tax.scope == 'LINE_ITEM' && tax.item_type == 'products'"
                        type="button"
                        @click="addProducts"
                    )
                        | Add Products

                    button.btn.btn-sm.btn-block.white.m-t-1(
                        v-if="tax.scope == 'LINE_ITEM' && tax.item_type == 'fuels'"
                        type="button"
                        @click="addFuels"
                    )
                        | Add Fuels

                    button.btn.btn-sm.btn-block.white.m-t-1(
                        v-if="tax.scope == 'LINE_ITEM' && tax.item_type == 'tags'"
                        type="button"
                        @click="addTags"
                    )
                        | Add Tags

                div.form-group
                    label Options

                    div.form-group
                        p
                            label.md-switch
                                input.has-value(
                                    type="checkbox"
                                    name="amount_type"
                                    @change="setTaxValue($event.target.checked, 'amount_type')"
                                    :checked="tax.amount_type"
                                )
                                i.indigo
                                | {{ taxText }}
                        p
                            small Change amount type between percentage and fixed amount

                    div.form-group
                        p
                            label.md-switch
                                input.has-value(
                                    type="checkbox",
                                    name="assign-outlet",
                                    @change="setTaxValue($event.target.checked, 'auto_assign_outlet')",
                                    :checked="tax.auto_assign_outlet"
                                )
                                i.indigo
                                | Auto assign to outlet
                        p
                            small Automatically assign tax when new outlet created
                
                div.form-group
                    p
                        label.md-switch
                            input.has-value(
                                type="checkbox",
                                name="tax_before_discount",
                                @change="setTaxValue($event.target.checked, 'tax_before_discount')",
                                :checked="tax.tax_before_discount",
                                :disabled="!tax.inclusive"
                            )
                            i.indigo
                            | Calculate tax {{ tax.tax_before_discount ? 'before' : 'after' }} discount
                    p
                        small Determine whether the discount should be applied before or after the tax calculation. (Applicable for Inclusive Tax only)
                
                div.form-group
                    p
                        label.md-switch
                            input.has-value(
                                type="checkbox",
                                name="auto_assign_product",
                                @change="setTaxValue($event.target.checked, 'auto_assign_product')",
                                :checked="tax.auto_assign_product"
                            )
                            i.indigo
                            | Auto assign to product
                    p
                        small Automatically assign tax when new product is created

                div.form-group
                    p
                        label.md-switch
                            input.has-value(
                                :true-value="1"
                                :false-value="0"
                                v-model="tax.status"
                                type="checkbox"
                            )
                            i.indigo
                            | Active tax
                    p
                        small Tax will be applied in orders

    button.btn.btn-fw.primary(
        slot="footer"
        @click="submit"
        :disabled="onLoading('save-tax') || !canManageTaxes"
    )
        v-loading(loader="save-tax") Save
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PermissionMixin from '../tax-permission';
import DatepickerInput from '@js/components/datepicker/datepicker.vue';
import m from 'moment';

export default {
    components: { DatepickerInput },

    mixins: [PermissionMixin],

    data() {
        return {
            scopes: [
                {
                    id: 'LINE_ITEM',
                    name: 'Line Item',
                },
                {
                    id: 'ORDER',
                    name: 'Order',
                },
            ],
        };
    },

    computed: {
        ...mapGetters('tax', ['tax']),

        ...mapGetters('product', {
            productList: 'products',
        }),

        taxExists() {
            return this.tax.id !== null;
        },

        allProductsHasAsigned() {
            return this.products.length == this.productList.length;
        },

        min() {
            return moment().startOf('day');
        },

        products: {
            get() {
                return this.tax.products;
            },
            set(value) {
                this.setTaxValue(value, 'products');
            },
        },

        amountModes() {
            return [
                { name: 'Inclusive Tax', value: true },
                { name: 'Exclusive Tax', value: false },
            ];
        },

        itemTypes() {
            return [
                { name: 'Products', value: 'products' },
                { name: 'Fuels', value: 'fuels' },
                { name: 'Tags', value: 'tags' },
            ];
        },

        applicationModes() {
            return [
                { name: 'Apply on subtotal amount', value: 0 },
                { name: 'Apply on every product amounts', value: 1 },
            ];
        },

        inclusiveMultiselect: {
            get() {
                if (this.tax == null) return false;

                let m = this.amountModes.find(
                    x => x.value == this.tax.inclusive,
                );

                if (m == undefined) {
                    m = this.amountModes[1];
                }

                return m;
            },

            set(value) {
                this.setTaxValue(value.value, 'inclusive');
                if (!value.value) {
                    this.setTaxValue(false, 'tax_before_discount');
                }
            },
        },

        modeMultiselect: {
            get() {
                if (this.tax == null) return null;

                let m = this.applicationModes.find(
                    x => x.value == this.tax.mode,
                );

                if (m == undefined) {
                    m = this.applicationModes[0];
                }

                return m;
            },

            set(value) {
                this.setTaxValue(value.value, 'mode');
            },
        },

        taxItemType: {
            get() {
                if (this.tax == null) return null;

                return this.itemTypes.find(x => x.value == this.tax.item_type);
            },

            set(value) {
                this.setTaxValue(value.value, 'item_type');
            },
        },

        taxText() {
            return this.tax.amount_type ? 'RM' : '%';
        },

        deactivateMinDate() {
            return m().startOf('day');
        },

        disableItemType() {
            return !_.isNull(this.tax.id);
        },
    },

    mounted() {
        this.registerEvent();
        this.getProductList({
            limit: null,
            query: null,
            relation: 0,
        });
    },

    methods: {
        ...mapActions('tax', [
            'setTaxAttribute',
            'getTax',
            'createTax',
            'updateTax',
        ]),

        ...mapActions('product', ['getProductList']),

        setTaxValue(value, key) {
            this.setTaxAttribute({ key, value });
        },

        async submit() {
            this.errors.clear();

            let submit;

            const validate = await this.validateDatePickerForm();
            const validateAddOutlet = this.validateAddOutletForm();

            if (
                !this.validateForm('tax-form') ||
                !validate ||
                !validateAddOutlet
            )
                return;

            this.startLoading('save-tax');

            const addProductsForm = this.$parent.$refs.addProductsForm;
            const addOutletsForm = this.$parent.$refs.addOutletsForm;

            let filters = null;
            let outletFilters = null;

            if (!_.isUndefined(addProductsForm)) {
                const addAllMatching = this.$parent.$refs.addProductsForm
                    .addAllMatching;

                filters = addAllMatching
                    ? this.$parent.$refs.addProductsForm.filters
                    : null;
            }

            if (!_.isUndefined(addOutletsForm)) {
                const outletSelectAll = this.$parent.$refs.addOutletsForm
                    .outletSelectAll;

                outletFilters = outletSelectAll
                    ? this.$parent.$refs.addOutletsForm.filters
                    : null;
            }

            if (this.taxExists) {
                submit = this.updateTax({ filters, outletFilters });
            } else {
                submit = this.createTax({ filters, outletFilters });
            }

            submit
                .then(res => {
                    this.showToastrSuccess();
                    this.endLoading('save-tax');

                    if (!this.taxExists) this.resetTaxForm();
                    else $('#tax-form-modal').modal('hide');

                    this.$emit('tax-saved');
                })
                .catch(err => {
                    this.endLoading('save-tax');
                    this.showApiError(err);
                    throw err;
                });
        },

        async validateDatePickerForm() {
            const validate = await this.$validator.validate();

            if (!validate) {
                const elem = $('input:text.parsley-error');
                if (elem.length) {
                    elem[0].focus();
                }

                let item = this.$validator.errors.items[0];

                this.errors.add({
                    field: item.field,
                    msg: item.msg,
                });
            }

            return validate;
        },

        validateAddOutletForm() {
            const outletSelectAll = this.$parent.$refs.addOutletsForm
                .outletSelectAll;

            if (this.tax.outlets.length === 0 && !outletSelectAll) {
                this.errors.add({
                    field: 'add outlet',
                    msg: 'Please select at least 1 station',
                });

                return false;
            }

            return true;
        },

        resetTaxForm() {
            this.setTaxValue(null, 'id');
            this.setTaxValue(null, 'name');
            this.setTaxValue(null, 'short_name');
            this.setTaxValue(null, 'amount');
            this.setTaxValue(0, 'mode');
            this.setTaxValue(false, 'inclusive');
            this.setTaxValue(true, 'auto_assign_outlet');
            this.setTaxValue(true, 'auto_assign_product');
            this.setTaxValue(false, 'tax_before_discount');
            this.setTaxValue(false, 'amount_type');
            this.setTaxValue([], 'products');
            this.setTaxValue([], 'fuels');
            this.setTaxValue([], 'tags');
            this.setTaxValue([], 'outlets');
            this.setTaxValue(true, 'status');
            this.setTaxValue(moment().startOf('day'), 'effective_at');
            this.setTaxValue(null, 'deactivate_at');
            this.setTaxValue('LINE_ITEM', 'scope');
            this.setTaxValue(null, 'item_type');
        },

        registerEvent() {
            this.$on('show-form', id => {
                if (id !== null) {
                    this.getTax(id).then(tax => {
                        $('#tax-form-modal').modal('show');
                    });
                } else {
                    this.resetTaxForm();
                    $('#tax-form-modal').modal('show');
                }
            });
        },

        assignAllProducts() {
            this.setTaxValue(this.productList, 'products');
        },

        addProducts() {
            this.$parent.$refs.addProductsForm.registerTax(this.tax);
            this.$parent.$refs.addProductsForm.showModal();
        },

        addOutlets() {
            this.$parent.$refs.addOutletsForm.registerTax(this.tax);
            this.$parent.$refs.addOutletsForm.showModal();
        },

        addTags() {
            this.$parent.$refs.addTagsForm.registerTax(this.tax);
            this.$parent.$refs.addTagsForm.showModal();
        },

        addFuels() {
            this.$parent.$refs.addFuelsForm.registerTax(this.tax);
            this.$parent.$refs.addFuelsForm.showModal();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tax/tax_form.vue